import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import galleryConfig from '../config/galleryConfig.json';
import SEO from '../components/SEO';

const Gallery = () => {
  const { gallery, posts } = galleryConfig;
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (post) => {
    setSelectedImage(post);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const handleBackdropClick = (e) => {
    if (e.target.className.includes('lightbox-backdrop')) {
      closeLightbox();
    }
  };

  return (
    <section className="gallery-page">
      <SEO
        title="Treatment Gallery | ART Aesthetics & Skincare Widnes"
        description="Explore treatment room highlights and skincare results from ART Aesthetics & Skincare in Widnes."
        path="/gallery"
      />
      <div className="gallery-container">
        <motion.div
          className="gallery-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">{gallery.title}</h1>
          <p className="page-subtitle">{gallery.subtitle}</p>
        </motion.div>

        <div className="gallery-grid">
          {posts.map((post, index) => (
            <motion.div
              key={post.id}
              className="gallery-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              onClick={() => openLightbox(post)}
            >
              <div className="gallery-image-wrapper">
                <img 
                  src={post.image} 
                  alt={post.caption}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/400x400/E8DCC4/7A6F5D?text=Instagram+Post';
                  }}
                />
                <div className="gallery-overlay">
                  <p className="gallery-caption">{post.caption}</p>
                  <span className="view-post">View Post →</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="instagram-cta"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>See More on Instagram</h2>
          <p>Follow us for daily inspiration, tips, and client transformations</p>
          <a 
            href={gallery.instagramUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="cta-button primary"
          >
            @{gallery.instagramHandle}
          </a>
        </motion.div>
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="lightbox-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleBackdropClick}
          >
            <motion.div
              className="lightbox-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", damping: 25 }}
            >
              <button className="lightbox-close" onClick={closeLightbox}>
                ✕
              </button>
              <img 
                src={selectedImage.image} 
                alt={selectedImage.caption}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/800x800/E8DCC4/7A6F5D?text=Instagram+Post';
                }}
              />
              <div className="lightbox-info">
                <p className="lightbox-caption">{selectedImage.caption}</p>
                <a 
                  href={selectedImage.instagramPostUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="instagram-link"
                >
                  View on Instagram →
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;
